import PricingList from "../../../components/admin/pricing/PricingList";
import Footer from "../../../components/layout/footer";
import Header from "../../../components/layout/header";

const Pricing = () => {
  return (
    <>
      <Header Logout={true} />
      <PricingList />
      <Footer />
    </>
  );
};
export default Pricing;
